import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { getAccessToken } from "../../api/getAccessToken";

export type TestSendUserOption = {
  username: string;
  user_id: string;
};

type UsersPage = {
  items?: Array<{ username?: string; user_id?: string }>;
};

type UsersEnvelope = {
  data?: UsersPage;
};

const SEARCH_PAGE_SIZE = 10;

export function isForbiddenError(error: unknown): boolean {
  const status = (error as { response?: { status?: number } } | undefined)?.response
    ?.status;
  return status === 403;
}

async function fetchUsers(search: string): Promise<TestSendUserOption[]> {
  const instance = createPrivateAdminPanelInstance(getAccessToken());
  const response = await instance.get(API_ROUTES.LIST_ADMIN_PANEL_USERS, {
    params: { search, page: 1, size: SEARCH_PAGE_SIZE },
  });
  const root = response?.data as UsersEnvelope | UsersPage | undefined;
  const page = (root as UsersEnvelope)?.data ?? (root as UsersPage | undefined);
  const items = Array.isArray(page?.items) ? page.items : [];
  return items
    .map((item) => ({
      username: (item.username ?? "").trim(),
      user_id: (item.user_id ?? "").trim(),
    }))
    .filter((item) => item.username.length > 0);
}

export const SEARCH_TEST_SEND_USERS_QUERY_KEY = "SEARCH_TEST_SEND_USERS" as const;

export function useSearchTestSendUsers(search: string, enabled = true) {
  const trimmed = search.trim();
  return useQuery<TestSendUserOption[], Error>({
    queryKey: [SEARCH_TEST_SEND_USERS_QUERY_KEY, trimmed],
    queryFn: () => fetchUsers(trimmed),
    enabled: enabled && trimmed.length > 0,
  });
}
